import React, { useState } from 'react'
import { useStateValue } from '@State'
import { MEModal } from '@CommonComponents'
import { submitAssessment } from '../api'
import { QuestionList } from './QuestionList'

export const AssessmentCanvas = () => {
  const [state, dispatch] = useStateValue()
  const { coursenum, activitySubmissionId, submitStatus, readonly, questions } = state
  const [unansweredCount, setUnansweredCount] = useState(0)

  const doSubmit = async () => {
    dispatch({ type: 'SUBMIT_START' })
    try {
      await submitAssessment(coursenum, activitySubmissionId)
      dispatch({ type: 'SUBMIT_SUCCESS' })
      window.location.reload()
    } catch (e) {
      dispatch({ type: 'SUBMIT_ERROR' })
    }
  }

  const handleSubmit = () => {
    const count = (questions || []).reduce((acc, q) => {
      if (q.type === 'caseset') return acc + (q.questions || []).filter(subQ => !subQ.ngnCasesetSubmitted).length
      return acc + (q.isAnswered ? 0 : 1)
    }, 0)
    if (count > 0) {
      setUnansweredCount(count)
    } else {
      doSubmit()
    }
  }

  return (
    <div>
      <QuestionList />
      {!readonly && (
        <div className="mt-3">
          <button
            className="btn btn-primary"
            onClick={handleSubmit}
            disabled={submitStatus === 'submitting'}
          >
            {submitStatus === 'submitting'
              ? 'Submitting...'
              : 'Submit Assessment'}
          </button>
          {submitStatus === 'error' && (
            <p className="text-danger mt-2">
              There was an error submitting. Please try again.
            </p>
          )}
        </div>
      )}
      <MEModal
        show={unansweredCount > 0}
        close={() => setUnansweredCount(0)}
        title="Ready to Submit"
      >
        <p>{unansweredCount} question{unansweredCount !== 1 ? 's' : ''} may still be unanswered. Are you sure you want to submit?</p>
        <div className="d-flex justify-content-center">
          <button className="btn btn-myed btn-primary btn-primary-myed mr-2" onClick={() => { setUnansweredCount(0); doSubmit() }}>Yes</button>
          <button className="btn btn-myed btn-default btn-default-myed" onClick={() => setUnansweredCount(0)}>No</button>
        </div>
      </MEModal>
    </div>
  )
}
